import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PrintedSweatshirt = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.PrintedSweatshirt.itemName}
      name={AW23.tops.PrintedSweatshirt.itemName}
      price={AW23.tops.PrintedSweatshirt.itemPrice}
      fabric={AW23.tops.PrintedSweatshirt.itemFabric}
      src={AW23.tops.PrintedSweatshirt.sizeChart}
      divId={AW23.tops.PrintedSweatshirt.shopifyDivId}
      mainId={AW23.tops.PrintedSweatshirt.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.PrintedSweatshirt.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.PrintedSweatshirt.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PrintedSweatshirt;
